
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'
// const sysInfo = {
//   apiRemote: 'http://47.111.75.34:8080/app/mock/22/data'
// }
export function insertPlaceholder (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/placeholder',
    method: 'POST',
    data: parameter
  })
}
export function updatePlaceholder (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/placeholder',
    method: 'PUT',
    data: parameter
  })
}
export function deletePlaceholder (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/placeholder',
    method: 'DELETE',
    params: {
      id: parameter
    }
  })
}
export function getPlaceholderList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/placeholder',
    method: 'GET',
    params: parameter
  })
}
export function getPlaceholderInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/data/perm/placeholder',
    method: 'GET',
    params: parameter
  })
}
